export const styles = {
  container: 'tw-flex tw-flex-col tw-gap-2 tw-min-w-0 tw-overflow-hidden',
  parentRow: 'tw-flex tw-items-center tw-gap-2 tw-min-h-0 tw-min-w-0',
  parentCheckboxWrapper: 'tw-min-w-0 tw-flex-1',
  collapseTrigger:
    'tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded hover:tw-bg-neutral-100 tw-cursor-pointer tw-text-neutral-500 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-500',
  collapseIcon: 'tw-w-3 tw-h-3 tw-transition-transform',
  childrenContainer: 'tw-ml-6 tw-flex tw-flex-col tw-gap-2 tw-mt-1 tw-min-w-0 tw-overflow-hidden',
};
